<template>
  <div>
    <s-crud
      title="Historial de Auditorías"
      :config="config"
      :filter="filter"
      searchInput
      ref="historyCrud"
    >
      <template v-slot:filter>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="4" lg="3">
              <s-date
                v-model="filter.SecCreate"
                label="Fecha de Auditoría"
                clearable
                :max="new Date().toISOString().substr(0, 10)"
                />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </s-crud>
  </div>
</template>

<script>
import _sAuditService from "@/services/HumanResource/RecruitmentSelection/AuditService.js";

export default {
  name: "HmnAuditView",

  data() {
    return {
      filter: {
        SecCreate: null,
      },
      config: {
        model: {
          MauID: "ID",
          SecCreate: "datetime"
        },
        service: _sAuditService,
        headers: [
          { text: "Nombre", value: "UsrName" },
          { text: "Dia/hora", value: "SecCreate", width: "8%" },
          { text: "Accion ", value: "ActionName", width: "8%" },
          { text: "Accion Original", value: "OriginAction", width: "8%" },
          { text: "Es Administrador", value: "IsAdmin", width: "8%" },
          { text: "Codigo Documento", value: "DocCode", width: "8%" },
          { text: "Entidad Afectada", value: "EntityName" },
          { text: "ID Documento", value: "DocID", width: "8%" },
          { text: "Modulo", value: "ModuleName", width: "8%" },
          { text: "Permisos elevados", value: "PermissionHard", width: "8%" },
          { text: "Ruta Original", value: "OriginRoute", width: "8%" },
        ],
      },
    };
  },
};
</script>
